// Centralized data layer exports for App2
// This file provides a clean API surface for the data layer

// Generated OpenAPI types and clients
export * from "./gen";

// Pagination defaults/caps (numeric values from Orval `ClientPaginationLimits*` in `./gen`)
export * from "./pagination";

// Shared API error helpers (single source of truth lives in the generated client mutator)
export {getApiErrorMessage} from "./axios-instance";

// HTTP API hooks (repos) - Generic/reusable only
export {
	useWhoAmI,
	useGetMe,
	useGetFeed,
	useGetUpcomingLessons,
	useGetEnrolledCourses,
	useGetOverdueLessons,
	useUpdateSettings,
	useRequestAutoEnrollment,
	useRefreshStats,
	type UseRefreshStatsOptions,
	useGetMyRecentActivity,
	useGetMyActiveCourses,
	useGetMyFinishedCourses,
	// Query keys for cache invalidation
	QUERY_KEYS
} from "./repos/user";

export {
	useGetStreakInfo,
	useUpdateStreakState,
	STREAK_QUERY_KEYS
} from "./repos/streaks";

export {
	useGetUserLeaderboard,
	useListCohortLeaderboard,
	useListCohortLeaderboardInfinite,
	useListAwardEvents,
	LEADERBOARDS_QUERY_KEYS,
	LEADERBOARD_MODAL_PAGE_SIZE,
	invalidateLeaderboardQueries
} from "./repos/leaderboards";

export {
	useListPlaylists,
	useGetPlaylist,
	useGetPlaylistCertification,
	useCreatePlaylist,
	useUpdatePlaylist,
	useDeletePlaylist,
	useBulkEnrollUsersInPlaylist,
	useBulkUnenrollUsersFromPlaylist,
	useBulkCompletePlaylistEnrollments,
	useEnrollCohortInPlaylist,
	PLAYLIST_QUERY_KEYS,
	PLAYLIST_ENROLLMENTS_QUERY_PREFIX,
	type PlaylistListItem,
	type ListPlaylistsParams,
	type PlaylistFiltersDto,
	type PlaylistAttributeFilterDto,
	type PlaylistDetail,
	type PlaylistCourse,
	type CreatePlaylistBody,
	type UpdatePlaylistBody,
	type BulkEnrollPlaylistParams,
	type BulkUnenrollPlaylistParams
} from "./repos/playlists";

export {
	useSearchCourses,
	useListCourses,
	useListCourseEnrollments,
	useListPlaylistEnrollments,
	// Course page
	useGetCourseDetails,
	useGetCourseCurriculum,
	COURSES_QUERY_KEYS,
	// Lesson & Quiz in course context
	useGetLessonForCourse,
	getLessonForCourseQueryKey,
	useGetQuizForCourse,
	// Bulk enrollment (HTTP - replaces WebSocket)
	useBulkEnrollUsers,
	useManageDueDates,
	useSelfEnrollInCourse,
	useBulkUnenrollUsers,
	useEnrollCohortInCourse,
	useBulkCompleteCourseEnrollments,
	// Course blacklist toggle
	useToggleCourseBlacklist,
	// Admin CRUD operations
	useGetAdminCourse,
	useCreateCourse,
	useUpdateCourse,
	useDeleteCourse,
	useListCourseLessons,
	useListCourseQuizzes,
	// Curriculum builder hooks
	useGetCourseModules,
	useGetCurriculumItems,
	type EnrollmentType,
	type BulkEnrollParams,
	type BulkUnenrollParams,
	// Export types until they're in gen
	type CourseEnrollmentDto,
	type ListCourseEnrollmentsResponse,
	type CoursesControllerListEnrollmentsParams,
	type CourseEnrollmentFilterCondition,
	type CourseEnrollmentFiltersPayload
} from "./repos/courses";

export {
	useFlushLessonVideoProgress,
	LESSON_VIDEO_PROGRESS_SOCKET_EVENT,
	type FlushLessonVideoProgressParams
} from "./repos/socket-events";

export {
	useGetI18nLocales,
	SETTINGS_QUERY_KEYS
} from "./repos/settings";

export {
	useGetNotifications,
	useRegisterNotificationToken,
	useMarkNotificationsRead,
	useMarkNotificationReadById,
	NOTIFICATIONS_QUERY_KEYS,
	type GetNotificationsResponse,
	type GetNotificationsParams,
	type NotificationLogItemDto
} from "./repos/notifications";

export {
	useGetLearnerAssignedAnnouncements,
	useGetLearnerAnnouncementsNotifications,
	useCompleteAnnouncement,
	useListCohortAnnouncements,
	useGetAnnouncement,
	useCreateAnnouncement,
	useUpdateAnnouncement,
	useDeleteAnnouncement,
	usePublishAnnouncement,
	useDraftAnnouncement,
	useGetAnnouncementEnrollments,
	ANNOUNCEMENTS_QUERY_KEYS,
	ANNOUNCEMENT_ENROLLMENTS_MAX_PAGE_SIZE,
	type UseGetAnnouncementEnrollmentsOptions,
	type GetLearnerAssignedResponse,
	type GetLearnerAssignedParams,
	type LearnerAssignedAnnouncementDto,
	type GetLearnerNotificationsResponse,
	type GetLearnerNotificationsParams,
	type LearnerNotificationItemDto,
	type ListCohortAnnouncementsParams,
	type ListCohortAnnouncementsResponse,
	type AdminAnnouncementListItem,
	type GetAnnouncementResponse,
	type CreateAnnouncementBody,
	type UpdateAnnouncementBody
} from "./repos/announcements";

export {
	useGetTeamProgressTiles,
	useGetTeamProgressChart,
	useGetCompletedLessons,
	useGetCompletedCourses,
	useGetActiveUsers,
	useGetInactiveUsers,
	useGetTimeInTraining,
	useGetOverdueLessonsForTeamProgress,
	// Don't export response types (they're internal to gen)
	// Export individual DTO types only
	type CompletedLessonDto,
	type CompletedCourseDto,
	type ActiveUserDto,
	type InactiveUserDto,
	type TimeInTrainingDto,
	type OverdueLessonsDto
} from "./repos/team-progress";


// Lesson enrollment operations (inline quizzes)
export {
	useGetInlineQuizQuestions,
	useGetInlineQuizLatestResult,
	useSubmitInlineQuiz,
	LESSON_ENROLLMENT_QUERY_KEYS,
	type InlineQuizQuestionDto
} from "./repos/lesson-enrollments";

// Lesson mutations with cache invalidation (types from gen)
export {
	useCompleteLesson,
	useSaveVideoTime,
	useBulkCompleteLessons,
	useSearchLessons,
	useGetLesson,
	useListLessons,
	useCreateLesson,
	useUpdateLesson,
	useDeleteLesson,
	useUploadLessonFile,
	LESSON_QUERY_KEYS,
	type CreateLessonMutationVariables
} from "./repos/lessons";

// Re-export generated lesson types
export type {PostLessonBody, PutLessonBody, UploadFilesResponse} from "./gen";

// Quiz hooks
export {
	useGetQuiz,
	useGetQuizQuestions,
	useSubmitQuiz,
	useListQuizzes,
	useCreateQuiz,
	useUpdateQuiz,
	useDeleteQuiz,
	QUIZ_QUERY_KEYS,
	type ListQuizItemDto,
	type ListQuizzesResponse,
	type ListQuizzesParams,
	type DeleteQuizResponse,
	type QuizListRow,
	type QuizDetailDto,
	type CreateQuizBody,
	type CreateQuizResponse,
	type UpdateQuizBody,
	type UpdateQuizResponse
} from "./repos/quizzes";

// Quiz Builder hooks
export {
	useGetQuizWithQuestions,
	useSearchQuestions,
	useCreateQuizQuestion,
	useUpdateQuizComposition,
	type QuestionSlim,
	type QuizWithQuestions,
	type SearchQuestionsParams,
	type SearchQuestionsResult,
	type CreateQuizQuestionBody,
	type CreateQuizQuestionResponse
} from "./repos/quizBuilder";

// Admin user endpoints (plural /api/users/:userId/*)
export {
	useListUsers,
	useGetUserFeed,
	useGetUserOverdueLessons,
	useGetUserRecentActivity,
	useGetUserActiveCourses,
	useGetUserActivePlaylists,
	useGetUserFinishedCourses,
	useGetUserRecommendedCourses,
	useBulkUnenrollUserFromCourses,
	USERS_QUERY_KEYS,
	type UserListDto,
	type ListUsersParams,
	type ListUsersResponse
} from "./repos/users";

// Cohort settings (admin)
export {
	useGetCohortSettings,
	useUpdateCohortSettings,
	COHORT_SETTINGS_QUERY_KEYS
} from "./repos/cohorts";

// Re-export cohort types
export type {ExtendedAccessDto} from "./gen";

// Notes operations
export {
	useSearchNotes,
	useCreateNote,
	useUpdateNote,
	useDeleteNote,
	NOTES_QUERY_KEYS,
	type CreateNoteParams,
	type CreateNoteResponse
} from "./repos/notes";

// Scheduled Reports (Month-End Reports)
export {
	useGetScheduledReportsOverview,
	useGetScheduledReportsTopPerformers,
	useGetScheduledReportsUsersWithout,
	useGetScheduledReportsDivisions,
	useGetScheduledReportsSupervisors,
	useGetDistributionRecipients,
	useAddDistributionRecipients,
	useRemoveDistributionRecipient,
	useGetScheduledReportsSaved,
	useGetScheduledReportById,
	useGenerateScheduledReport,
	useRegenerateScheduledReport,
	useDeleteScheduledReport,
	getScheduledReportPdfDownloadUrl,
	downloadScheduledReportPdf,
	SCHEDULED_REPORTS_QUERY_KEYS,
	type SavedReportMeta,
	type SavedReportWithData,
	type ScheduledReportData,
	type DistributionRecipient,
	type ScheduledReportOverview,
	type ScheduledReportTopPerformer,
	type ScheduledReportDivisionRow,
	type ScheduledReportSupervisorRow,
	type ScheduledReportUserWithoutRow,
	type OverviewParams,
	type PaginatedParams
} from "./repos/scheduled-reports";

export {
	useSearchComments,
	useSearchCommentsInfinite,
	useCreateComment,
	COMMENTS_QUERY_KEYS,
	type CommentDto,
	type CommentAuthorDto,
	type SearchCommentsParams,
	type SearchCommentsResponse,
	type CreateCommentParams
} from "./repos/comments";

export {
	useGetCourseLibraryBanner,
	COURSE_LIBRARY_BANNER_QUERY_KEY
} from "./repos/course-library-banner";

export {
	brightcoveInit,
	brightcoveComplete,
	brightcoveQuery,
	useBrightcoveQueryVideo,
	isBrightcoveQueryPlayable,
	BRIGHTCOVE_QUERY_KEYS,
	type BrightcoveInitResponse,
	type BrightcoveInitData,
	type BrightcoveCompleteBody,
	type BrightcoveCompleteResponse,
	type BrightcoveQueryBody,
	type BrightcoveQueryResponse,
	type BrightcoveApiConfig
} from "./repos/brightcove";

